import React from 'react';
import AnimatedCounter from '../AnimatedCounter';
import { useCMS } from '../../context/CMSContext';

export const StatsSection = () => {
  const cms = useCMS();
  const stats = cms?.stats || [];

  return (
    <section className="py-32 bg-gradient-to-br from-amber-500 via-orange-500 to-red-500 relative overflow-hidden">
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxnIGZpbGw9IiNmZmZmZmYiIGZpbGwtb3BhY2l0eT0iMC4wNSI+PHBhdGggZD0iTTM2IDE0YzAtNi42MjcgNS4zNzMtMTIgMTItMTJzMTIgNS4zNzMgMTIgMTItNS4zNzMgMTItMTIgMTItMTItNS4zNzMtMTItMTJ6Ii8+PC9nPjwvZz48L3N2Zz4=')] opacity-20" />
      <div className="relative max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="font-outfit text-5xl font-black text-white mb-4">Trusted by Thousands</h2>
          <p className="text-xl text-white/90">Numbers that speak for themselves</p>
        </div>
        <div className={`grid gap-12 ${stats.length <= 3 ? 'md:grid-cols-3' : 'md:grid-cols-4'}`}>
          {stats.map(stat => {
            const numMatch = stat.value?.match(/(\d+)/);
            const num = numMatch ? parseInt(numMatch[1]) : 0;
            const suffix = stat.value?.replace(/\d+/, '') || '';
            return (
              <div key={stat.label} className="text-center">
                <div className="text-7xl font-black text-white mb-3">{num > 0 ? <AnimatedCounter end={num} suffix={suffix} /> : stat.value}</div>
                <p className="text-2xl text-white/95 font-bold">{stat.label}</p>
                <p className="text-white/70 mt-2">{stat.sub}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
